export default __webpack_public_path__ + "static/media/signal_good.b788e355.svg";